import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { FilterType } from '../filtering-module';
import { FieldType } from 'src/app/models/Item';

@Component({
  template: `
    <form [formGroup]="formEdit" >
      <mat-dialog-content>
              <mat-list>
                    <mat-list-item *ngFor="let f of appliedFilters; let i = index">
                      <div class='filterDiv'>
                        <mat-form-field class="filterName">
                          <mat-label i18n="@@filterDialog.chooseFilter">Wybierz filtr</mat-label>
                            <mat-select #filter  (selectionChange)='filterChanged(i,filter.value)'  [(value)]="appliedFilters[i].filter">
                              <mat-option *ngFor="let filter of filterName | keyvalue" [value]="filter.key">
                              {{filter.value}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="filterType">
                          <mat-label i18n="@@filterDialog.chooseFilterType">Wybierz typ</mat-label>
                            <mat-select #type (selectionChange)='typeChanged(i,type.value)' [(value)]="appliedFilters[i].type">
                              <mat-option *ngFor="let filter of filterType  | keyvalue" [value]="filter.key">
                              {{filter.value}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div [ngStyle]="{'display': (appliedFilters[i].filter !== FieldType.LastEntry &&
                              appliedFilters[i].filter !== FieldType.PurchaseDate) ? 'initial' : 'none'}" >
                          <mat-form-field class="filterData">
                            <mat-label i18n="@@filterDialog.filterData">Dane</mat-label>
                            <input matInput autocomplete="off"  (input)='textChanged(i, $event.target.value)'
                            [(value)]="appliedFilters[i].args[0]">
                          </mat-form-field>
                        </div>

                        <div [ngStyle]="{'display': (appliedFilters[i].filter === FieldType.LastEntry ||
                            appliedFilters[i].filter === FieldType.PurchaseDate) ? 'initial' : 'none'}" >
                          <mat-form-field class='callendarRange'>
                              <mat-label i18n="@@filterDialog.filterDateFrom">Data(od):</mat-label>
                              <input matInput [matDatepicker]="picker"  autocomplete="off"  [(value)]="appliedFilters[i].args[0]"
                              (dateInput)='dateChanged(i, 0, $event.target.value)'>
                              <mat-datepicker-toggle matSuffix [for]="picker">
                              </mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>

                          <mat-form-field class='callendarRange'>
                              <mat-label i18n="@@filterDialog.filterDateTo">Data(do):</mat-label>
                              <input matInput [matDatepicker]="picker2"  autocomplete="off"  [(value)]="appliedFilters[i].args[1]"
                              (dateInput)='dateChanged(i, 1, $event.target.value)'>
                              <mat-datepicker-toggle matSuffix [for]="picker2">
                              </mat-datepicker-toggle>
                              <mat-datepicker #picker2></mat-datepicker>
                          </mat-form-field>
                        </div>

                        <img class ="filterButton" src="/assets/remove.png" (click)="removeFilter(i)">
                      </div>
                    </mat-list-item>
              </mat-list>
              <button  (click)="addFilter()" i18n="@@filterDialog.addAnotherFilter">Dodaj kolejny filtr</button>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button  (click)="reset()" i18n="@@filterDialog.filterReset">RESET</button>
        <button  (click)="save()" i18n="@@filterDialog.filterOk">OK</button>
      </mat-dialog-actions>
    </form>
  `,
  styleUrls: ['./filter-dialog.component.css']
})

export class FilterDialogComponent implements OnInit {
  formEdit: FormGroup;
  fieldName: string;
  FieldType = FieldType;
  filterName: Map<FieldType, string> ;
  filterType: Map<FilterType, string> ;
  appliedFilters: Array<FilterItem>;

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<FilterDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data) {
    this.appliedFilters = data.filters;
    if ((this.appliedFilters === undefined) || (this.appliedFilters.length === 0)) {
      this.appliedFilters = new Array<FilterItem>();
      this.appliedFilters.push(new FilterItem(null, null, ['', ''] ));
    } else {

    }

    this.filterType = new Map<FilterType, string>();
    this.filterType.set(FilterType.Contain,  $localize`:@@filterDialog.Contain:Zawiera`);
    this.filterType.set(FilterType.Exclude,  $localize`:@@filterDialog.Exclude:Nie zawiera`);

    this.filterName = new Map<FieldType, string>();
    this.filterName.set(FieldType.Category,  $localize`:@@filterDialog.Category:Kategoria`);
    this.filterName.set(FieldType.Description,  $localize`:@@filterDialog.Description:Opis`);
    this.filterName.set(FieldType.LastEntry,  $localize`:@@filterDialog.LastEntry:Ostatni wpis`);
    this.filterName.set(FieldType.LastUser,  $localize`:@@filterDialog.User:Użytkownik`);
    this.filterName.set(FieldType.Location,  $localize`:@@filterDialog.Location:Lokalizacja`);
    this.filterName.set(FieldType.Mark,  $localize`:@@filterDialog.Mark:Marka`);
    this.filterName.set(FieldType.PurchaseDate,  $localize`:@@filterDialog.PurchaseDate:Data zakupu`);
    this.filterName.set(FieldType.Remarks,  $localize`:@@filterDialog.Remarks:Uwagi`);
    this.filterName.set(FieldType.State,  $localize`:@@filterDialog.StateSize:Stan/Rozmiar`);
    this.filterName.set(FieldType.Title,  $localize`:@@filterDialog.Title:Tytuł`);
   }

  ngOnInit(): void {
    this.formEdit = this.formBuilder.group({});
  }

  reset() {
    this.appliedFilters = [];
  }

  save() {
    this.dialogRef.close(this.appliedFilters);
  }

  addFilter() {
    this.appliedFilters.push(new FilterItem(FilterType.Contain, FieldType.Mark, ['', ''] ));
  }

  removeFilter(i) {
    this.appliedFilters.splice(i, 1);
  }

  filterChanged(i, filter) {
    this.appliedFilters[i].filter = filter;
  }

  typeChanged(i, type) {
    this.appliedFilters[i].type = type;
  }

  textChanged(i, value) {
    this.appliedFilters[i].args = [value];
  }

  dateChanged(i, argNr, value) {
    this.appliedFilters[i].args[argNr] = value;
  }
}

export class FilterItem {

  constructor(type: FilterType, filter: FieldType, args: Array<any>) {
    this.type = type;
    this.filter = filter;
    this.args = args;
  }

  type: FilterType ;
  filter: FieldType ;
  args: Array<any>;
}
